import React from 'react';
import slugify from '@sindresorhus/slugify';

import Link from './renderers/Link';
import Heading from './renderers/Heading';
import CardCTA from './CardCTA';

const FAQCategoryCard = ({ title, slug, faqs }) => {
  const noOfFAQs = faqs.length;

  if (noOfFAQs === 0) return null;

  return (
    <article className="flex flex-col p-4">
      <Heading children={title} level={4} />

      <ul className="list-none list-inside my-4">
        {faqs.slice(0, 3).map(({ id, question }) => (
          <li key={id} className="mb-2 hover:underline">
            <Link
              className="text-cornflower"
              href={
                slug +
                '#' +
                slugify(question, {
                  customReplacements: [
                    ['/', ''],
                    ['.', ''],
                  ],
                  decamelize: false,
                })
              }
            >
              {question}
            </Link>
          </li>
        ))}
      </ul>
      <Link href={slug}>
        <CardCTA
          label={faqs.length > 1 ? `View all ${noOfFAQs} FAQs` : `View FAQs`}
        />
      </Link>
    </article>
  );
};

export default FAQCategoryCard;
